import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatOptionModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import {
  BadgeModule,
  DziViewerModule,
  GridViewModule,
  ImageModule,
  LoadingAttributeComponent,
  NavigationBreadcrumbComponent,
  UniversalSearchBarModule,
} from '@shared/ui';
import { ViewersFeatureModule } from '@shared/viewers/feature';
import { LabelCreatorModule } from '@telespot/shared/label-creator';
import { CompactNumberPipeModule, HasKeysPipeModule } from '@telespot/shared/util';
import { TelespotModule } from '@telespot/web-core';

import {
  AcquisitionDataComponent,
  AiAnalysisInProgressBannerComponent,
  AiAnalysisSelectionPanelComponent,
  AnalysisInputComponent,
  AnalysisLayoutComponent,
  AnalysisTopBarComponent,
  AnalystSelectorComponent,
  AssetFiltersComponent,
  CropDetailComponent,
  FilterSetEditorComponent,
  ImageFiltersComponent,
  LabelContextMenuComponent,
  LabelSelectionPanelComponent,
  MicroProtocolCellComponent,
  MicroProtocolHeaderComponent,
  MicroscopeImageComponent,
  MicroscopeVideoComponent,
  MobileAnalysisPanelComponent,
  MosaicCellComponent,
  MosaicDashboardComponent,
  MosaicEditorModeComponent,
  MosaicGalleryComponent,
  MosaicRowNumberComponent,
  MosaicSectionHeaderComponent,
  MosaicTileSettingsComponent,
  NewClassDialogComponent,
  ProtocolCellComponent,
  ProtocolHeaderComponent,
  ProtocoloPanelComponent,
  RulerSelectorComponent,
  SampleAnalysisPanelComponent,
  SampleAnalysisToolsComponent,
  SegmentationProtocolCellComponent,
  StatsSettingsComponent,
  ViewerToolsComponent,
} from './components';
import { EditorKeybindingsDirective } from './directives';

@NgModule({
  imports: [
    CommonModule,
    BadgeModule,
    ImageModule,
    TranslateModule,
    MatTabsModule,
    MatTooltipModule,
    RouterModule,
    MatProgressSpinnerModule,
    MatMenuModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatProgressBarModule,
    MatDividerModule,
    GridViewModule,
    DragDropModule,
    OverlayModule,
    MatExpansionModule,
    MatChipsModule,
    MatCheckboxModule,
    MatBadgeModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    MatSliderModule,
    MatToolbarModule,
    HasKeysPipeModule,
    LabelCreatorModule,
    ViewersFeatureModule,
    NavigationBreadcrumbComponent,
    CompactNumberPipeModule,
    LoadingAttributeComponent,
    TelespotModule,
    UniversalSearchBarModule,
    DziViewerModule,
  ],
  exports: [
    LabelContextMenuComponent,
    LabelSelectionPanelComponent,
    CropDetailComponent,
    MosaicCellComponent,
    MosaicRowNumberComponent,
    RulerSelectorComponent,
    MosaicSectionHeaderComponent,
    MosaicGalleryComponent,
    ProtocolCellComponent,
    ProtocolHeaderComponent,
    ProtocoloPanelComponent,
    MicroProtocolCellComponent,
    MicroProtocolHeaderComponent,
    SegmentationProtocolCellComponent,
    EditorKeybindingsDirective,
    DziViewerModule,
    FilterSetEditorComponent,
    MosaicTileSettingsComponent,
    MosaicEditorModeComponent,
    StatsSettingsComponent,
    CompactNumberPipeModule,
    AcquisitionDataComponent,
    AiAnalysisInProgressBannerComponent,
    AiAnalysisSelectionPanelComponent,
    AnalysisInputComponent,
    AnalysisLayoutComponent,
    AnalysisTopBarComponent,
    AnalystSelectorComponent,
    AssetFiltersComponent,
    ImageFiltersComponent,
    MobileAnalysisPanelComponent,
    NewClassDialogComponent,
    SampleAnalysisPanelComponent,
    SampleAnalysisToolsComponent,
    ViewerToolsComponent,
    MicroscopeImageComponent,
    MicroscopeVideoComponent,
    MosaicDashboardComponent,
  ],
  declarations: [
    LabelContextMenuComponent,
    LabelSelectionPanelComponent,
    MosaicCellComponent,
    MosaicRowNumberComponent,
    RulerSelectorComponent,
    MosaicSectionHeaderComponent,
    MosaicGalleryComponent,
    ProtocolCellComponent,
    ProtocolHeaderComponent,
    ProtocoloPanelComponent,
    MicroProtocolCellComponent,
    MicroProtocolHeaderComponent,
    SegmentationProtocolCellComponent,
    CropDetailComponent,
    EditorKeybindingsDirective,
    FilterSetEditorComponent,
    MosaicTileSettingsComponent,
    MosaicEditorModeComponent,
    StatsSettingsComponent,
    AcquisitionDataComponent,
    AiAnalysisInProgressBannerComponent,
    AiAnalysisSelectionPanelComponent,
    AnalysisInputComponent,
    AnalysisLayoutComponent,
    AnalysisTopBarComponent,
    AnalystSelectorComponent,
    AssetFiltersComponent,
    ImageFiltersComponent,
    MobileAnalysisPanelComponent,
    NewClassDialogComponent,
    SampleAnalysisPanelComponent,
    SampleAnalysisToolsComponent,
    ViewerToolsComponent,
    MicroscopeImageComponent,
    MicroscopeVideoComponent,
    MosaicDashboardComponent,
  ],
})
export class AnalysisUiModule {}
